import React, { Component } from 'react';
import { Jumbotron, Nav, NavItem, Panel, Modal } from 'react-bootstrap';
import Forecast from './react-forecast';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import $ from 'jquery';
import './App.css';
window.jQuery = $;
window.$ = $;
global.jQuery = $;
const bootstrap = require('bootstrap');

class Location {
  constructor(lat, lon) {
    this.lat = lat;
    this.lon = lon;
  }
}

class Stats {
  constructor(pistes, chairlifts, tBars, pomas) {
    this.pistes = pistes;
    this.chairlifts = chairlifts;
    this.tBars = tBars;
    this.pomas = pomas;
  }
  
}

class Prices {
  constructor(dayPass, setHire, mainHire, helmetHire) {
    this.dayPass = dayPass;
    this.setHire = setHire;
    this.mainHire = mainHire;
    this.helmetHire = helmetHire;
  }
  
}

class Resort {
  constructor(name, prices, stats, location, pisteMapFile, url) {
    this.name = name;
    this.prices = prices;
    this.stats = stats;
    this.location = location;
    this.pisteMapFile = pisteMapFile;
    this.url = url;
  }
}

let resorts = [
  new Resort("Glenshee", new Prices(30, 22, 19, 5), new Stats(40, 3, 3, 16), new Location(56.886424, -3.414563), "glenshee-piste-map.jpg", "ski-glenshee.co.uk"),
  new Resort("Glencoe", new Prices(32, 25, 20, 5), new Stats(16, 2, 1, 5), new Location(56.633184, -4.827670), "glencoe-piste-map.jpg", "glencoemountain.com"),
  new Resort("Cairngorm Mountain", new Prices(36, 25.5, 20.5, 8), new Stats(30, 0, 4, 5), new Location(57.133777, -3.670250), "cairngorm-piste-map.jpg", "cairngormmountain.org"),
  new Resort("Nevis Range", new Prices(34.5, 24.5, 17.5, 3), new Stats(20, 3, 3, 5), new Location(56.852145, -4.998762), "nevis-piste-map.jpg", "nevisrange.co.uk"),
  new Resort("Lecht", new Prices(30, 22, NaN, NaN), new Stats(25, 1, 0, 12), new Location(57.203430, -3.250386), "lecht-piste-map.jpg", "lecht.co.uk")
];

class ResortSelector extends Component {
  render() {
    return (
      <Nav
        id="resorts"
        bsStyle="tabs"
        justified
        activeKey={this.props.data.current_resort.name}
        onSelect={(key) => this.props.data.onClick(key)}>
          {resorts.map((resort) => <NavItem key={resort.name} eventKey={resort.name}>{resort.name}</NavItem>)}
      </Nav>
    );
  }
}

const ResortMap = withScriptjs(withGoogleMap((props) => {
  let loc = props.location;
  return <GoogleMap
    defaultZoom={7}
    defaultCenter={{ lat: loc.lat, lng: loc.lon }}>
    <Marker position={{ lat: loc.lat, lng: loc.lon }} />
  </GoogleMap>
}));

class ResortLocation extends Component {
  render() {
    return <ResortMap 
      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBUbgb3yYK8Y7sekIvsILIS6NvgakPZKRs&v=3.exp&libraries=geometry,drawing,places"
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div style={{ height: `400px` }} />}
      mapElement={<div style={{ height: `100%` }} />}
      location={this.props.location}
    />;
  }
}



class ResortInfo extends Component {

  static format(amount, unit, isPrefix) {
    if (isNaN(amount)) {
      return "N/A";
    }

    if (isPrefix) {
      return unit + amount;
    } else {
      return amount + unit;
    }
  }

  constructor(props, context) {
    super(props, context);
    this.showPisteMapPopup = this.showPisteMapPopup.bind(this);
    this.hidePisteMapPopup = this.hidePisteMapPopup.bind(this);
    this.state = {
      showPisteMapPopup: false
    };
  }

  showPisteMapPopup() {
    this.setState({showPisteMapPopup: true});
  }

  hidePisteMapPopup() {
    this.setState({showPisteMapPopup: false});
  }

  render() {
    let resort = this.props.resort;
    return (
      <div id="resort-info">
        <h2>
          {resort.name}
          <a href={"http://" + resort.url} target="_blank" rel="noopener noreferrer">{resort.url}</a>
        </h2>
        <Forecast latitude={resort.location.lat} longitude={resort.location.lon} name={resort.name} units="ca" width="100%" height={245} />
        <Panel className="resort-data">
          <Panel.Heading>
            <Panel.Title>Prices</Panel.Title>
          </Panel.Heading>
          <p>Day pass: {ResortInfo.format(resort.prices.dayPass, "£", true)}</p>
          <p>Set hire: {ResortInfo.format(resort.prices.setHire, "£", true)}</p>
          <p>Ski/board hire: {ResortInfo.format(resort.prices.mainHire, "£", true)}</p>
          <p>Helmet hire: {ResortInfo.format(resort.prices.helmetHire, "£", true)}</p>
        </Panel>
        <Panel className="resort-data">
          <Panel.Heading>
            <Panel.Title>Stats</Panel.Title>
          </Panel.Heading>
          <p>Pistes: {ResortInfo.format(resort.stats.pistes, "km")}</p>
          <p>Chairlifts: {resort.stats.chairlifts}</p>
          <p>T-bars: {resort.stats.tBars}</p>
          <p>Pomas: {resort.stats.pomas}</p>
        </Panel>
        <Panel className="piste-map">
          <Panel.Heading>
            <Panel.Title>Piste map</Panel.Title>
          </Panel.Heading>
          <img alt={resort.name + " piste map"} src={"img/" + resort.pisteMapFile} onClick={() => this.showPisteMapPopup()} />
          <Modal show={this.state.showPisteMapPopup} onHide={this.hidePisteMapPopup} dialogClassName="piste-map-dialog">
            <Modal.Header closeButton>
              <Modal.Title>Piste map</Modal.Title>
            </Modal.Header>
            <img className="piste-map-full" alt={resort.name + " piste map"} src={"img/" + resort.pisteMapFile} />
          </Modal>
        </Panel>
        <Panel className="location">
          <Panel.Heading>
            <Panel.Title>Location</Panel.Title>
          </Panel.Heading>
          <ResortLocation location={resort.location} />
        </Panel>
      </div>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resort: resorts[0]
    };
  }

  handleClick(resortKey) {
    let resort = resorts.find((r) => resortKey === r.name);
    this.setState({resort: resort});
  }

  render() {
    let resortSelectorProps = {
      current_resort: this.state.resort,
      onClick: (resort) => this.handleClick(resort)
    };
    return (
      <div id="skiing-scotland">
        <Jumbotron className="header">
          <h1 className="title">Skiing Scotland</h1>
          <p className="intro">Scottish ski resorts at your fingertips.</p>
        </Jumbotron>
        <ResortSelector data={resortSelectorProps} />
        <ResortInfo resort={this.state.resort} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js